export default "__VITE_ASSET__6853bb92__"